var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1388,
    height: 423,
    viewBox: "0 0 1388 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_31)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 236.337,
    cy: 206.221,
    r: 3,
    transform: "rotate(-5.56626 236.337 206.221)",
    fill: "url(#paint0_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.337,
    cy: 206.221,
    r: 2.5,
    transform: "rotate(-5.56626 236.337 206.221)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 236.337,
    cy: 206.222,
    r: 1,
    transform: "rotate(-5.56626 236.337 206.222)",
    fill: "url(#paint1_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236.337,
    cy: 206.222,
    r: 0.833333,
    transform: "rotate(-5.56626 236.337 206.222)",
    stroke: "white",
    strokeWidth: 0.333333
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 236.337,
    cy: 206.221,
    r: 12,
    transform: "rotate(-5.56626 236.337 206.221)",
    fill: "url(#paint2_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1113.11 109.722)",
    fill: "url(#paint3_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1113.11 109.722)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1111.31 111.907)",
    fill: "url(#paint4_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.833333,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1111.31 111.907)",
    stroke: "white",
    strokeWidth: 0.333333
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1121.2 99.8916)",
    fill: "url(#paint5_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.6003,
    cy: 311.772,
    r: 4,
    transform: "rotate(-5.56626 29.6003 311.772)",
    fill: "url(#paint6_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.6003,
    cy: 311.772,
    r: 3.5,
    transform: "rotate(-5.56626 29.6003 311.772)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.6003,
    cy: 311.772,
    r: 2,
    transform: "rotate(-5.56626 29.6003 311.772)",
    fill: "url(#paint7_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.6003,
    cy: 311.772,
    r: 1.66667,
    transform: "rotate(-5.56626 29.6003 311.772)",
    stroke: "white",
    strokeWidth: 0.666667
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.6003,
    cy: 311.772,
    r: 12,
    transform: "rotate(-5.56626 29.6003 311.772)",
    fill: "url(#paint8_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1005.12 42.8819)",
    fill: "url(#paint9_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1005.12 42.8819)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1003.32 45.0665)",
    fill: "url(#paint10_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.66667,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1003.32 45.0665)",
    stroke: "white",
    strokeWidth: 0.666667
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1012.3 34.1436)",
    fill: "url(#paint11_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.3188,
    cy: 162.994,
    r: 2,
    transform: "rotate(-5.56626 61.3188 162.994)",
    fill: "url(#paint12_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.3188,
    cy: 162.994,
    r: 1.75,
    transform: "rotate(-5.56626 61.3188 162.994)",
    stroke: "white",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.3188,
    cy: 162.994,
    r: 1,
    transform: "rotate(-5.56626 61.3188 162.994)",
    fill: "url(#paint13_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.3188,
    cy: 162.994,
    r: 0.833333,
    transform: "rotate(-5.56626 61.3188 162.994)",
    stroke: "white",
    strokeWidth: 0.333333
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.3188,
    cy: 162.994,
    r: 12,
    transform: "rotate(-5.56626 61.3188 162.994)",
    fill: "url(#paint14_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1363.7 175.727)",
    fill: "url(#paint15_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.75,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1363.7 175.727)",
    stroke: "white",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1362.8 176.82)",
    fill: "url(#paint16_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.833333,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1362.8 176.82)",
    stroke: "white",
    strokeWidth: 0.333333
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1372.68 164.805)",
    fill: "url(#paint17_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.935,
    cy: 345.949,
    r: 12,
    transform: "rotate(-5.56626 245.935 345.949)",
    fill: "url(#paint18_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.935,
    cy: 345.949,
    r: 3,
    transform: "rotate(-5.56626 245.935 345.949)",
    fill: "url(#paint19_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.935,
    cy: 345.949,
    r: 2.5,
    transform: "rotate(-5.56626 245.935 345.949)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 245.935,
    cy: 345.949,
    r: 2,
    transform: "rotate(-5.56626 245.935 345.949)",
    fill: "url(#paint20_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.935,
    cy: 345.949,
    r: 1.75,
    transform: "rotate(-5.56626 245.935 345.949)",
    stroke: "white",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1259.13 51.2831)",
    fill: "url(#paint21_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1251.05 61.1136)",
    fill: "url(#paint22_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1251.05 61.1136)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1250.15 62.2059)",
    fill: "url(#paint23_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.75,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1250.15 62.2059)",
    stroke: "white",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 253.936,
    r: 12,
    transform: "rotate(-5.56626 375.622 253.936)",
    fill: "url(#paint24_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 253.936,
    r: 4,
    transform: "rotate(-5.56626 375.622 253.936)",
    fill: "url(#paint25_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 253.936,
    r: 3.5,
    transform: "rotate(-5.56626 375.622 253.936)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 253.936,
    r: 1,
    transform: "rotate(-5.56626 375.622 253.936)",
    fill: "url(#paint26_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.622,
    cy: 253.936,
    r: 0.875,
    transform: "rotate(-5.56626 375.622 253.936)",
    stroke: "white",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1069.52 229.515)",
    fill: "url(#paint27_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1062.34 238.253)",
    fill: "url(#paint28_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1062.34 238.253)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1059.64 241.53)",
    fill: "url(#paint29_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.875,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1059.64 241.53)",
    stroke: "white",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.144,
    cy: 225.398,
    r: 12,
    transform: "rotate(-5.56626 225.144 225.398)",
    fill: "url(#paint30_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.144,
    cy: 225.398,
    r: 3,
    transform: "rotate(-5.56626 225.144 225.398)",
    fill: "url(#paint31_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.144,
    cy: 225.398,
    r: 2.5,
    transform: "rotate(-5.56626 225.144 225.398)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 225.144,
    cy: 225.398,
    r: 1,
    transform: "rotate(-5.56626 225.144 225.398)",
    fill: "url(#paint32_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.144,
    cy: 225.398,
    r: 0.75,
    transform: "rotate(-5.56626 225.144 225.398)",
    stroke: "white",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1237.26 280.485)",
    fill: "url(#paint33_radial_1_31)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1229.18 290.316)",
    fill: "url(#paint34_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1229.18 290.316)",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_1_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1227.38 292.5)",
    fill: "url(#paint35_radial_1_31)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.75,
    transform: "matrix(-0.995285 0.0969968 0.0969968 0.995285 1227.38 292.5)",
    stroke: "white",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_31",
    x: 14.5994,
    y: 32.2501,
    width: 1362.3,
    height: 328.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_31",
    x: 226.337,
    y: 196.221,
    width: 20.0005,
    height: 20.0004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_31",
    x: 234.67,
    y: 204.555,
    width: 3.33333,
    height: 3.33346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.333333,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_31",
    x: 210.336,
    y: 180.221,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1_31",
    x: 1100.42,
    y: 102.999,
    width: 20.0005,
    height: 20.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1_31",
    x: 1108.75,
    y: 111.332,
    width: 3.33358,
    height: 3.33358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.333333,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1_31",
    x: 1084.42,
    y: 86.9981,
    width: 52.0017,
    height: 52.0018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1_31",
    x: 18.6001,
    y: 300.772,
    width: 22.0005,
    height: 22.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1_31",
    x: 26.2668,
    y: 308.439,
    width: 6.66716,
    height: 6.66703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666667,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1_31",
    x: 3.59937,
    y: 285.771,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1_31",
    x: 990.525,
    y: 36.2507,
    width: 22.0007,
    height: 22.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1_31",
    x: 998.192,
    y: 43.9176,
    width: 6.66691,
    height: 6.66691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666667,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1_31",
    x: 975.524,
    y: 21.2501,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_1_31",
    x: 55.8186,
    y: 157.494,
    width: 11.0005,
    height: 11.0004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_1_31",
    x: 59.6522,
    y: 161.327,
    width: 3.33333,
    height: 3.33346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.333333,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_1_31",
    x: 35.3179,
    y: 136.993,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_1_31",
    x: 1356.4,
    y: 172.412,
    width: 11.0002,
    height: 11.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_1_31",
    x: 1360.23,
    y: 176.245,
    width: 3.33358,
    height: 3.33358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.333333,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_1_31",
    x: 1335.9,
    y: 151.911,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_1_31",
    x: 219.934,
    y: 319.948,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_1_31",
    x: 235.935,
    y: 335.949,
    width: 20.0005,
    height: 20.0004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_1_31",
    x: 242.935,
    y: 342.949,
    width: 6.00049,
    height: 6.00037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_1_31",
    x: 1222.35,
    y: 38.3896,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_1_31",
    x: 1238.35,
    y: 54.3903,
    width: 20.0005,
    height: 20.0004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_1_31",
    x: 1245.35,
    y: 61.3904,
    width: 6.00024,
    height: 6.00024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_1_31",
    x: 349.621,
    y: 227.935,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_1_31",
    x: 364.622,
    y: 242.936,
    width: 22.0005,
    height: 22.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_1_31",
    x: 374.122,
    y: 252.436,
    width: 3,
    height: 3.00012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_1_31",
    x: 1032.74,
    y: 216.621,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_1_31",
    x: 1047.75,
    y: 231.622,
    width: 22.0007,
    height: 22.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_1_31",
    x: 1057.25,
    y: 241.122,
    width: 3.00024,
    height: 3.00024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_1_31",
    x: 199.143,
    y: 199.397,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_1_31",
    x: 215.144,
    y: 215.397,
    width: 20.0005,
    height: 20.0004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_1_31",
    x: 223.144,
    y: 223.398,
    width: 4,
    height: 4.00012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_1_31",
    x: 1200.48,
    y: 267.592,
    width: 52.0017,
    height: 52.0017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_1_31",
    x: 1216.48,
    y: 283.592,
    width: 20.0005,
    height: 20.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_1_31",
    x: 1224.48,
    y: 291.593,
    width: 4.00024,
    height: 4.00024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1_31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.337 206.221) rotate(90) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.337 206.222) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(236.337 206.221) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3 3) rotate(90) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1 1) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.6003 311.772) rotate(90) scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.6003 311.772) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.6003 311.772) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4 4) rotate(90) scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3188 162.994) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3188 162.994) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3188 162.994) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1 1) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.935 345.949) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.935 345.949) rotate(90) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(245.935 345.949) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3 3) rotate(90) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2 2) rotate(90) scale(2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(375.622 253.936) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(375.622 253.936) rotate(90) scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(375.622 253.936) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4 4) rotate(90) scale(4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1 1) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(225.144 225.398) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(225.144 225.398) rotate(90) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(225.144 225.398) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) rotate(90) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3 3) rotate(90) scale(3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1_31",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1 1) rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607764,
    stopColor: "#F7F7C5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeck);
export default __webpack_public_path__ + "static/media/speck.d4e35774e8150fc6704c20081b917e36.svg";
export { ForwardRef as ReactComponent };